import {createSlice} from '@reduxjs/toolkit';

export const userInitialState = {
  name: '',
  role: [],
  country: [],
  countryCode: '',
  siteId: ''
};

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: userInitialState,
  reducers: {
    setUserDetails: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    resetUserDetails: () => userInitialState
  }
});

export const {setUserDetails, resetUserDetails} = userDetailsSlice.actions;

export const userDetailsSliceReducer = userDetailsSlice.reducer;
